module.exports = __webpack_public_path__ + "img/btn_clear.c2a7d849.png";